import { FC, ReactNode } from "react"
import { Box, Card, CardActionArea, CardActionAreaProps, CardContent, lighten, Stack, Typography, useTheme } from "@mui/material"
import { grey } from "@mui/material/colors";
import { Tooltip, ITooltipProps } from "@gisce/oficina-virtual-components";

interface IActionElement extends CardActionAreaProps{
  title: string;
  description: string;
  icon?: ReactNode;
  toolTipProps?: Omit<ITooltipProps, 'children'>;
  showTooltip?: boolean;
}

const defaultTooltipProps: IActionElement["toolTipProps"] = {
  title: '',
  placement: 'right',
  arrow: true,
  slotProps: {
    popper: {
      modifiers: [{
        name: 'offset',
        options: {offset: [0, -5]}
      }]
    }
  }
}

export const ActionElement: FC<IActionElement> = ({
  title,
  description,
  icon,
  disabled,
  showTooltip = false,
  toolTipProps = defaultTooltipProps,
  onClick,
  ...rest
}) => {
  const theme = useTheme();
  return <>
    <Tooltip
      {...defaultTooltipProps}
      {...toolTipProps}
      disableFocusListener={!showTooltip}
      disableHoverListener={!showTooltip}
      disableTouchListener={!showTooltip}
    >
      <Card elevation={0}>
        <CardActionArea sx={{
            border: '2px solid transparent',
            '& .MuiCardContent-root': {
              padding: {xs: 1},
            },
            '&:hover, &.Mui-focusVisible': disabled ? {
              color: grey[800],
              border: `2px solid ${grey[800]}`,
              backgroundColor: grey[200]
            } : {
              color: theme.palette.primary.main,
              border: `2px solid ${theme.palette.primary.main}`,
              backgroundColor: lighten(theme.palette.primary.main, 0.9)
            },
            color: disabled ? grey[500] : 'inherit'
          }}
          {...rest}
          onClick={disabled ? undefined : onClick}
          disableRipple={disabled}
        >
          <CardContent>
            <Stack direction="row" spacing={1}>
              <Box pt={0.5}>{icon}</Box>
              <Box>
                <Typography gutterBottom variant="h6" component="div">
                  {title}
                </Typography>
                <Typography variant="body2" sx={{color: grey[700]}}>
                  {description}
                </Typography>
              </Box>
            </Stack>
          </CardContent>
        </CardActionArea>
      </Card>
    </Tooltip>
  </>
} 